import { toast } from '@navi/web-ui/lib/primitives/Toast';
import axiosInstance, { ApiKeys, getApiUrl } from '../../../utils/ApiHelper';
import { STORE_KEYS, ToastMessage } from '../constants';
import {
  setCaseDetail,
  setCaseDetailError,
  setCaseDetailLoading
} from '../reducers/caseDetailSlice';
import { Dispatch } from '@reduxjs/toolkit';

interface dispatchProps {
  payload: any;
  type: string;
}
export const fetchAddresses = (
  lan: string,
  customerRefrenceId: string,
  caseReferenceId: string,
  caseBusinessVertical: string
) => {
  const url = getApiUrl(ApiKeys.ADDRESSES);
  return function (dispatch: ({ payload, type }: dispatchProps) => void) {
    dispatch(
      setCaseDetailLoading({
        lan,
        customerRefrenceId,
        key: STORE_KEYS.ADDRESSES,
        loading: true
      })
    );
    axiosInstance
      .get(url, {
        headers: {
          customerreferenceid: customerRefrenceId,
          loanaccountnumber: lan,
          caseReferenceId,
          caseBusinessVertical,
          includeInUptimeMetrics: true
        }
      })
      .then(response => {
        dispatch(
          setCaseDetail({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.ADDRESSES,
            data: response.data
          })
        );
      })
      .catch(err => {
        dispatch(
          setCaseDetailError({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.ADDRESSES,
            error: err
          })
        );
      });
  };
};

export const postAlternateNumber =
  ({
    loanaccountnumber,
    customerreferenceid,
    caseReferenceId,
    caseBusinessVertical,
    alternateNumber,
    customerConfidence,
    source,
    successCallback,
    cb,
    otherSource,
    successToastMessage,
    identifier,
    proofOfSource
  }: {
    loanaccountnumber: string;
    customerreferenceid: string;
    caseReferenceId: string;
    caseBusinessVertical: string;
    alternateNumber: string;
    customerConfidence?: string;
    source: string;
    successCallback?: () => void;
    cb?: (isModalOpen: boolean) => void;
    otherSource?: string;
    successToastMessage?: string;
    identifier?: string;
    proofOfSource?: File | null;
  }) =>
  () => {
    const formData = new FormData();
    if (proofOfSource) {
      formData.append('proofOfSource', proofOfSource);
    }
    const jsonData = {
      number: alternateNumber,
      source: 'LONGHORN',
      secondarySource: source,
      remarkForSecondarySource: otherSource,
      type: 'Alternate Contact',
      numberCustomId: identifier,
      telephoneCustomerConfidence: customerConfidence
    };
    formData.append('telephonePayload', JSON.stringify(jsonData));

    axiosInstance
      .post(getApiUrl(ApiKeys.TELEPHONES), formData, {
        headers: {
          customerreferenceid,
          loanaccountnumber,
          caseReferenceId,
          caseBusinessVertical,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        if (successToastMessage) {
          toast(successToastMessage, { type: 'success' });
        } else toast(ToastMessage.NUMBER_ADDED_SUCCESSFULLY, { type: 'success' });
        cb && cb(false);
        successCallback && successCallback();
      })
      .catch(err => {
        if (err.message) {
          toast(err.message, { type: 'error' });
        } else toast(ToastMessage.NUMBER_ADDITION_FAILED, { type: 'error' });
      });
  };

export const getValidateNumber = async (number: string, customerRefId: string) => {
  const url = getApiUrl(ApiKeys.VALIDATE_PHONE_NUMBER, { number });
  try {
    const response = await axiosInstance.get(url, {
      headers: { customerReferenceId: customerRefId }
    });
    return response.data;
  } catch (error) {
    return 'Error';
  }
};

export const postAlternateEmail = (
  loanaccountnumber: string,
  customerreferenceid: string,
  emailAddress: string,
  successCallback: () => void,
  failureCallback: () => void
) => {
  axiosInstance
    .post(
      getApiUrl(ApiKeys.EMAILS),
      {
        emailAddress,
        entityType: 'CUSTOMER',
        businessVertical: 'CENTRAL',
        source: 'LONGHORN',
        entityId: customerreferenceid
      },
      {
        headers: { customerreferenceid, loanaccountnumber }
      }
    )
    .then(() => {
      successCallback();
      toast(ToastMessage.EMAIL_ADDED_SUCCESSFULLY, { type: 'success' });
    })
    .catch(() => {
      failureCallback();
      toast(ToastMessage.EMAIL_ADDITION_FAILED, { type: 'error' });
    });
};
